import {api} from './api'

export interface PaginationParams {
  limit?: number
  page?: number
  filter_by_email?: string
}

export interface IUsers {
  id: string
  username: string,
  full_name: string,
  type: string,
  verified: string,
  created_at: string,
  updated_at: string
}

export interface IUserUpdate {
  name: string
  email: string
}

interface IListResponse<IUsers> {
  users: IUsers[]
  records_count: number
  next_page: number | null
  previous_page: number | null
}

export const usersApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUsers: build.query<IListResponse<IUsers>, PaginationParams>({
      query: (params) => {
        return { url: `/users`, params, method: 'GET' }
      },
      providesTags: ['TeamMembers']
    }),
    updateUser: build.mutation<IUserUpdate, { body: Partial<IUserUpdate> }>({
      query: ({ body }) => ({
        url: `/users`,
        method: 'PUT',
        body
      }),
      invalidatesTags: (result, error) => [
        { type: 'TeamMembers' },
        { type: 'TeamMembers', id: 'PARTIAL-LIST' }
      ]
    }),
    getLogs: build.query<any, any>({
      query: (params) => {
        const { startDate, endDate, ...otherParams } = params;
        let url = '/logs';
        const queryParams = new URLSearchParams(otherParams as any);

        if (startDate && endDate) {
          queryParams.append('filter_by', `created_at:">=${startDate}" created_at:"<=${endDate}"`);
        }

        return {
          url: `${url}?${queryParams.toString()}`,
          method: 'GET'
        };
      },
    }),
  })

})

export const {
  useGetUsersQuery,
  useUpdateUserMutation,
  useGetLogsQuery, // Add this new hook
} = usersApi
